
import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { Badge } from '@/components/ui/badge';
import { Eye, EyeOff } from 'lucide-react';

interface WebhookItemProps {
  name: string;
  description: string;
  url: string;
  secret: string;
  active: boolean;
  editing: boolean;
  showSecret: boolean;
  onToggleSecret: () => void;
}

const WebhookItem: React.FC<WebhookItemProps> = ({
  name,
  description,
  url,
  secret,
  active,
  editing,
  showSecret,
  onToggleSecret
}) => {
  return (
    <div className="border rounded-md p-4">
      <div className="flex justify-between items-start mb-2">
        <div>
          <div className="flex items-center gap-2">
            <h4 className="font-medium">{name}</h4>
            <Badge variant="outline" className="text-xs">
              {active ? 'Active' : 'Inactive'}
            </Badge>
          </div>
          <p className="text-sm text-muted-foreground">{description}</p>
        </div>
        {editing && (
          <Switch 
            checked={active} 
            disabled={!editing}
          />
        )}
      </div>
      
      <div className="grid gap-2 mt-3">
        <Label htmlFor="webhook-url">Endpoint URL</Label>
        <Input 
          id="webhook-url" 
          disabled={!editing} 
          defaultValue={url}
          className="font-mono text-sm"
        />
      </div>
      
      <div className="flex items-center justify-between mt-3">
        <div className="text-sm">
          <span className="text-muted-foreground">Secret:</span> 
          <span className="font-mono ml-1">
            {showSecret ? secret : "••••••••••••••••••••"}
          </span>
        </div>
        <Button 
          variant="ghost" 
          size="sm" 
          className="h-8 w-8 p-0" 
          onClick={onToggleSecret}
        >
          {showSecret ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
        </Button>
      </div>
    </div>
  );
};

export default WebhookItem;
